// src/features/auth/RequireAuthGate.jsx
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty, isLoaded } from 'react-redux-firebase';
import { openModal } from '../modals/modalActions';

export default function RequireAuthGate() {
  const dispatch = useDispatch();
  const auth = useSelector((s) => s.firebase.auth);

  useEffect(() => {
    // Only open when auth is loaded & unauthenticated
    if (isLoaded(auth) && isEmpty(auth)) {
      dispatch(openModal('UnauthModal'));
    }
  }, [auth, dispatch]);

  // Render nothing; ModalManager will render the modal
  return null;
}
